import { logError } from "./errors"
import { makeApiCall } from "./gatewayUtils"
import apiConfig from "../apiConfig"

/*
 * Split from other utils so it doesn't include anything from Firebase.
 */

export const sendSlackMessage = (channel, icon, message) => {
  if (process.env.REACT_APP_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.log("Not sending slack message\n", message)
    return new Promise((r) => r())
  }

  const payload = {
    username: "Coastline Notification",
    icon_emoji: icon,
    channel,
    text: message,
  }

  const fetchInfo = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }

  return makeApiCall(apiConfig.slackMessage, fetchInfo).catch((error) => {
    logError(error, {
      eventId: error.cause || "not attached",
      channel: payload.channel,
      message: payload.text,
    })
  })
}
